import React from 'react';
import styled from 'styled-components';
import PageHeroSection from '../components/hero-section/PageHeroSection';
import IntelliCubixColoredImage from '../assets/general/intellicubix-colored.png';
import ContactForm from '../components/contact/ContactForm';

const MainContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 200px);
`;

const MainContent = styled.div`
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  padding: 50px 15px 15px 15px;
  max-width: 1170px;
  margin: 0 auto;
`

const IntelliCubixColored = styled.img`
  width: 350px;
  height: 59px;
  margin-bottom: 30px;
`;

const SubSectionTitle = styled.h3`
  font-size: 26px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.navy};
  font-family: ${(props) => props.theme.fonts.headline};
  text-align: justify;
  margin-bottom: 20px;

  span {
    color: ${(props) => props.theme.colors.magenta};
    font-weight: 700;
  }

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    text-align: left;
  }
`;

const SubSectionDescription = styled.p`
  font-size: 22px;
  font-weight: 300;
  color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fonts.content};
  text-align: justify;
  line-height: 1.3;
  margin-bottom: 20px;

  span {
    font-weight: 700;
    color: ${(props) => props.theme.colors.magenta};
  }
`;

const Contact = () => {
  return (
    <MainContainer>
      <PageHeroSection pageTitle="Contact" />
      <MainContent>
        <IntelliCubixColored src={IntelliCubixColoredImage} alt="Intellicubix Colored" />
        <SubSectionDescription>
        Welcome to the first step in your digital transformation journey with <span>Intellicubix</span>. Whether you're envisioning a groundbreaking app, seeking to leverage data analytics for strategic insights, or aiming to amplify your digital marketing efforts, we're here to bring your ideas to life. Let's start a conversation about how we can help elevate your business to unprecedented digital heights. Share your project details, schedule a consultation, or simply give us a call. Together, we'll craft a future where your business not only thrives but leads.
        </SubSectionDescription>
        <SubSectionTitle>
          Got a vision? We're all ears. Share your project dreams with us, and let's explore how <span>Intellicubix</span> can turn them into digital reality. Submit your story here.
        </SubSectionTitle>
        <ContactForm />
      </MainContent>
    </MainContainer>
  );
};

export default Contact;

